import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GraphDonut = _resolveComponent("GraphDonut")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: label.name
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(['label__name', label.style && `label__name-${label.style}`])
          }, _toDisplayString(label.name), 3),
          _createElementVNode("span", {
            class: _normalizeClass([
            'label__value',
            label.style && `label__value-${label.style}`,
          ])
          }, _toDisplayString(label.value), 3)
        ], 64))
      }), 128))
    ]),
    (_ctx.donutDefinition)
      ? (_openBlock(), _createBlock(_component_GraphDonut, _mergeProps({
          key: 0,
          "donut-definition": _ctx.donutDefinition,
          class: "donut"
        }, _ctx.$attrs), null, 16, ["donut-definition"]))
      : _createCommentVNode("", true)
  ]))
}